import React from 'react'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { Trans } from '../../atoms'
import { Breadcrumbs } from '../../molecules'
import FormTailorMade from '../../organisms/FormTailorMade/FormTailorMade'

const TailorMadeTemplate = ({ page }) => {
  const { width } = useWindowDimensions()

  return (
    <div
      className="tailor-made"
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          justifySelf: 'center',
          alignSelf: 'center',
          width: '80%',
          marginTop: 50,
        }}
      >
        <Breadcrumbs breadcrumbs={page?.breadcrumbs} />
        <h2 style={{ textAlign: 'left' }}>
          <Trans chiave="Ordini import - Articoli Tailor Made" />
        </h2>
      </div>
      {/* <MyImage
          src={page.main_image ? page.main_image : "https://placehold.co/728x90/png"}
          width={728}
          height={90}
          layout="responsive"
        /> */}
      <img
        src={page.main_image?.url}
        style={{ width: '100%', maxHeight: 300, margin: '20px 0px' }}
      />
      <div style={{ justifySelf: 'center', width: width > 600 ? '50%' : '80%' }}>
        <div style={{ textAlign: 'left' }}>
          <h2 style={{ marginBottom: 15 }}>
            <Trans chiave="Articoli Tailor Made di importazione diretta" />
          </h2>
          <div className="tailor-made__section">
            <p>
              Ordini speciali di improtazione diretta,{' '}
              <strong>articoli personalizzati sulla base delle vostre idee ed esigenze.</strong>
              Realizziamo anche articoli che non rientrano nel normale assortimento a catalogo,
              creati ad hoc per soddisfare specifiche esigenze del cliente e personalizzati
              direttamente in fase di produzione. Vuoi importare un prodotto? Sipec ti offre una
              soluzione chiavi in mano <strong>in 3 semplici passaggi</strong>{' '}
            </p>
          </div>

          <div className="tailor-made__section">
            <p>
              <strong>
                <Trans chiave="1) Seleziona il prodotto" />
              </strong>
            </p>
            <p>
              <Trans chiave="- dal catalogo" />
            </p>
            <p>
              <Trans chiave="- oppure indicaci un prodotto a tua scelta" />
            </p>
          </div>
          <div className="tailor-made__section">
            <p>
              <strong>
                <Trans chiave="2) Comunicaci le tue esigenze" />
              </strong>{' '}
            </p>
            <p>
              <Trans chiave="- quantità" />
            </p>
            <p>
              <Trans chiave="- colore (tra quelli disponibili a catalogo o il tuo colore pantone)" />
            </p>
            <p>
              <Trans chiave="- logo" />
            </p>
            <p>
              <Trans chiave="- tempi di consegna" />
            </p>
          </div>
          <div className="tailor-made__section">
            <p>
              <strong>
                <Trans chiave="3) Noi ti forniamo" />
              </strong>
            </p>
            <p>
              <Trans chiave="- la quotazione" />
            </p>
            <p>
              <Trans chiave="- il campione in formato digitale (o fisico)" />
            </p>
            <p>
              <Trans chiave="- la comunicazione di conferma ordine" />
            </p>
          </div>
        </div>
        <FormTailorMade />
      </div>
    </div>
  )
}

export default TailorMadeTemplate
